import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MARKET_MASTER_LIST_COLUMNS } from 'src/app/common/models/tableColumns';
import { environment } from 'src/environments/environment';
import { AdministrationService } from '../administration.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ConfirmSnackbarComponent } from 'src/app/common/confirm-snackbar/confirm-snackbar.component';
import { resolve } from 'dns';

@Component({
  selector: 'app-market-master',
  templateUrl: './market-master.component.html',
  styleUrls: ['./market-master.component.scss'],
})
export class MarketMasterComponent implements OnInit {
  marketMasterColumns: any[] = [];
  marketMasterListData: any[] = [];
  columnLength = 0;
  filteredRows: any[] = [];
  buttonSelection = false;

  loading = false;
  loadingMessage = '';
  selectedTableRow: any = null;
  openPopUp = false;
  editPopup = false;
  exportDialog = false;
  isSubmitting = false;

  selectedMarketName = '';
  selectedMarketCode = '';
  selectedMarketType: string | null = null;

  selectedCountry: any = null;
  selectedCountries: any[] = [];
  selectedFollowMarket: any[] = [];

  selectedPartOfCluster: any = null;
  selectedStatus: any = null;
  selectedPartOf1UL: any = null;

  selectedPrefOrder: string[] = [];
  selectedFastOrder: string[] = [];
  computedAssessmentOrder = '';

  marketTypeOptions = [
    { label: 'Country', value: 'Country' },
    { label: 'Cluster', value: 'Cluster' },
    { label: 'State', value: 'State' },
  ];

  statusOptions = [
    { label: 'Active', value: '1' },
    { label: 'In-Active', value: '0' },
  ];

  yesNoOptions = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];

  allMarketsList: any[] = [];
  followMarketOptions: any[] = [];
  allClustersList: any[] = [];
  enrichedClusterOptions: any[] = [];
  allCountriesList: any[] = [];
  masterCountriesList: any[] = [];
  allCountriesForEdit: any[] = [];
  masterCountriesForEdit: any[] = [];
  allCountriesForState: any[] = [];
  isCountriesPanelOpen = false;
  isFollowersPanelOpen = false;
  disableSubmitInEdit = true;
  computedAssessmentOrderCodes: string[] = [];
  clusterCircularError = '';
  isoCodeDuplicateError = '';
  nameDuplicateError = '';
  marketNameValidationError = '';
  cycleError = '';
  existingIsoCodes: Set<string> = new Set();
  existingNames: Set<string> = new Set();
  activeIsoCodes: Set<string> = new Set();
  activeNames: Set<string> = new Set();
  selectedRowData: any = null;
  disableSubmitInAdd = true;
  initialRawResponse: any;

  currentFilteredField = '';
  initialSelectedPartOfClusterCode: string | null = null;
  originalDirectParentClusterCode: string | null = null;
  initialSelectedCountryId: number | null = null;
  initialSelectedFollowerMarketIds: number[] = [];
  initialSelectedCountryIds: number[] = [];


  private readonly marketApiBase =
    environment.APIFAsT + '/market-management/markets';
  private readonly fastAssessmentOrderApiBase = environment.APIFAsT + '/market-management/fast-assessment-orders';
  private readonly followersApiBase = environment.APIFAsT + '/market-management/followers';
  constructor(
    private apiService: AdministrationService,
    private dialog: MatDialog,
    private http: HttpClient,
    public fb: FormBuilder,
    public router: Router,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
  ) { }

  private showAlert(type: 'success' | 'error', title: string, message: string, onOk?: () => void) {
    this.dialog.open(ConfirmSnackbarComponent, {
      data: { type, title, message, onOk },
      panelClass: 'confirm-alert-dialog',
      disableClose: true,
      width: '420px',
    });
  }
  async ngOnInit() {
    this.marketMasterColumns = MARKET_MASTER_LIST_COLUMNS;
    this.columnLength = this.marketMasterColumns.length;
    await this.getMarketMasterList();
    // this.loadDropdownData();
    this.selectedTableRow = null;
  }

  async getMarketMasterList(): Promise<void> {
    try {
      this.loading = true;
      this.loadingMessage = 'Getting Market Master List';
      // this.loadDropdownData(groupedFollowers); //b


      const apiUrl =
        this.marketApiBase + '?includeClusters=true&includeStates=true';

      // =========================
      // GET MARKETS
      // =========================

      const response: any = await this.apiService
        .getData(apiUrl)
        .toPromise();

      this.initialRawResponse = response;

      const data = Array.isArray(response) ? response : [];

      // =========================
      // GET FAST ASSESSMENT ORDERS
      // =========================

      const fastOrdersResponse: any = await this.apiService
        .getData(this.fastAssessmentOrderApiBase)
        .toPromise();

      const fastOrders = Array.isArray(fastOrdersResponse)
        ? fastOrdersResponse
        : [];

      // =========================
      // GET FOLLOWERS
      // =========================

      const followersResponse: any = await this.apiService
        .getData(this.followersApiBase)
        .toPromise();

      const followers = Array.isArray(followersResponse)
        ? followersResponse
        : [];

      // =========================
      // GROUP FAST ORDERS
      // =========================

      const groupedFastOrders = fastOrders.reduce(
        (acc: any, order: any) => {

          if (!acc[order.primaryMarketId]) {
            acc[order.primaryMarketId] = [];
          }

          acc[order.primaryMarketId].push(order);

          return acc;

        },
        {}
      );

      // =========================
      // GROUP FOLLOWERS
      // =========================

      const groupedFollowers = followers.reduce(
        (acc: any, follower: any) => {
          if (!acc[follower.leaderMarketId]) {
            acc[follower.leaderMarketId] = [];
          }
          acc[follower.leaderMarketId].push(follower);
          return acc;
        },
        {}
      );

      // =========================
      // ATTACH DATA TO MARKETS
      // =========================

      data.forEach((market: any) => {

        const marketId = parseInt(market.marketId, 10);

        // FAST ASSESSMENT ORDERS

        market.fastAssessmentOrders =
          (groupedFastOrders[marketId] || [])
            .sort((a: any, b: any) => a.distance - b.distance);

        market.fastAssessmentOrder =
          market.fastAssessmentOrders
            .map((order: any) => order.fallbackMarketIsoCode)
            .filter((code: any) => code != null);

        // FOLLOWER MARKETS

        market.followerMarkets =
          groupedFollowers[marketId] || [];

        market.followerMarketIds =
          market.followerMarkets
            .map((follower: any) => follower.followerMarketId)
            .filter((id: any) => id != null);

      });

      this.loadDropdownData(groupedFollowers); // b

      // =========================
      // SORT MARKETS
      // =========================

      const sorted = data.slice().sort((a: any, b: any) => {

        const d1 = new Date(a.createdDate || 0).getTime();
        const d2 = new Date(b.createdDate || 0).getTime();

        return d2 - d1;

      });

      this.marketMasterListData = sorted.map((item: any) =>
        this.mapResponseToRow(item)
      );

      return;

    } catch (error) {

      console.error(error);
      this.marketMasterListData = [];

      return;

    } finally {

      this.loading = false;
    }
  }

  loadDropdownData(groupedFollowers: any = {}) {

    const raw = this.initialRawResponse;

    const list: any[] = raw.map((m: any) => {
      let pCountryId: number | null = null;
      const isStateVal = !!(m.isState || m.IsState);
      if (isStateVal) {
        const parentCountryVal = m.parentCountryId || m.ParentCountryId || m.parentCountry;
        if (parentCountryVal != null) {
          if (typeof parentCountryVal === 'object') {
            const pId = parentCountryVal.marketId || parentCountryVal.id || parentCountryVal.Id || parentCountryVal.MarketId;
            if (pId != null) {
              pCountryId = parseInt(pId, 10);
            }
          } else {
            pCountryId = parseInt(parentCountryVal, 10);
          }
        }
      }

      const mId = parseInt(m.marketId || m.Id || m.id || m.MarketId, 10);
      const mName = m.marketName || m.MarketName || '';
      const mCode = m.isoCode || m.IsoCode || m.marketCode || m.MarketCode || '';
      const mCluster = !!(m.isCluster || m.IsCluster);
      const mStatus = m.fAsTStatus || m.fastStatus || m.FastStatus || m.fasTStatus || m.FAsTStatus || m.faststatus || m.status || m.Status || '';
      const mRawStatus = m.status || m.Status || '';
      const isOneUL = !!(m.isOneUnilever || m.IsOneUnilever);

      return {
        marketId: mId,
        marketName: mName,
        marketCode: mCode,

        isCluster: mCluster,
        isState: isStateVal,
        status: mStatus,
        rawStatus: mRawStatus,
        isOneUnilever: isOneUL,

        followerMarketIds: (groupedFollowers[mId] || []).map(
          (f: any) => parseInt(f.followerMarketId || f.FollowerMarketId, 10)
        ), // b

        prefAssessmentOrders: m.prefAssessmentOrders || m.PrefAssessmentOrders || [],
        fastAssessmentOrders: m.fastAssessmentOrders || m.FastAssessmentOrders || [],
        parentCountryId: pCountryId,
      };
    });



    console.log('----------------------->', list);

    const clusterCodes = new Set<string>(
      list.filter((m: any) => m.isCluster).map((m: any) => m.marketCode)
    );

    const countryParentClusterMap = new Map<number, any>();
    list.forEach((cluster: any) => {
      if (!cluster.isCluster) { return; }
      const isActiveCluster = cluster.status === 'InUseMarket' || cluster.status === 'Active';
      if (!isActiveCluster) { return; }

      (cluster.followerMarketIds || []).forEach((fId: any) => {
        if (fId != null) {
          const followerId = parseInt(fId, 10);
          const followerMarket = list.find((m: any) => m.marketId === followerId);
          if (followerMarket && !followerMarket.isCluster) {
            countryParentClusterMap.set(followerId, cluster);
          }
        }
      });

      (cluster.fastAssessmentOrders || []).forEach((order: any) => {
        if (order.fallbackMarketId != null) {
          const fallbackId = parseInt(order.fallbackMarketId, 10);
          const fallbackMarket = list.find((m: any) => m.marketId === fallbackId);
          if (fallbackMarket && !fallbackMarket.isCluster) {
            countryParentClusterMap.set(fallbackId, cluster);
          }
        }
      });
    });

    const tempAllMarkets = list.map((market: any) => {
      const fastCodes: string[] = Array.isArray(market.fastAssessmentOrders)
        ? market.fastAssessmentOrders
          .sort((a: any, b: any) => a.distance - b.distance)
          .filter((o: any) => o.fallbackMarketIsCluster === true || clusterCodes.has(o.fallbackMarketIsoCode))
          .map((o: any) => o.fallbackMarketIsoCode)
          .filter((x: any) => x && x !== market.marketCode)
        : [];

      return {
        ...market,
        fastCodes,
      };
    });

    const resolveAssessmentOrder = (m: any): string => {
      if (m.assessmentOrder) {
        return m.assessmentOrder;
      }
      if (m.assessmentOrderResolved) {
        return m.marketCode || '';
      }
      m.assessmentOrderResolved = true;

      if (m.isCluster) {
        m.assessmentOrder = m.fastCodes.length > 0
          ? [m.marketCode, ...m.fastCodes].join(' > ')
          : m.marketCode;
      } else if (m.isState) {
        const parentCountry = tempAllMarkets.find((x: any) => x.marketId === m.parentCountryId);
        if (parentCountry) {
          const parentOrder = resolveAssessmentOrder(parentCountry);
          m.assessmentOrder = [m.marketCode, parentOrder].join(' > ');
        } else {
          m.assessmentOrder = m.marketCode;
        }
      } else {
        // Country
        if (m.fastCodes && m.fastCodes.length > 0) {
          m.assessmentOrder = [m.marketCode, m.fastCodes[0]].join(' > ');
        } else {
          const parentCluster = countryParentClusterMap.get(m.marketId);
          if (parentCluster) {
            m.assessmentOrder = [m.marketCode, parentCluster.marketCode].join(' > ');
          } else {
            m.assessmentOrder = m.marketCode;
          }
        }
      }

      return m.assessmentOrder;
    };

    tempAllMarkets.forEach((market: any) => {
      resolveAssessmentOrder(market);
    });

    this.allMarketsList = tempAllMarkets;

    console.log('------------------->', this.allMarketsList);

    // =========================
    // ALL CLUSTERS LIST
    // =========================
    this.allClustersList = this.allMarketsList.filter(
      (m: any) => m.isCluster,
    );
    console.log('Clusters => ', this.allClustersList);

    // =========================
    // EXISTING ISO CODES
    // =========================
    this.existingIsoCodes = new Set(
      list
        .map((m: any) => {

          if (m.marketCode) {
            return m.marketCode.trim().toUpperCase();
          }

          return '';
        })
        .filter((x: any) => x),
    );

    this.existingNames = new Set(
      list
        .map((m: any) => {

          if (m.marketName) {
            return m.marketName.trim().toLowerCase();
          }

          return '';
        })
        .filter((x: any) => x),
    );

    this.activeIsoCodes = new Set(
      raw
        .filter((m: any) => {
          const status = m.status || m.Status || '';
          return status === 'InUseMarket' || status === 'Active';
        })
        .map((m: any) => {
          const code = m.isoCode || m.IsoCode || m.marketCode || m.MarketCode || '';
          return code ? code.trim().toUpperCase() : '';
        })
        .filter((x: any) => x)
    );

    this.activeNames = new Set(
      raw
        .filter((m: any) => {
          const status = m.status || m.Status || '';
          return status === 'InUseMarket' || status === 'Active';
        })
        .map((m: any) => {
          const name = m.marketName || m.MarketName || '';
          return name ? name.trim().toLowerCase() : '';
        })
        .filter((x: any) => x)
    );

    // =========================
    // CLUSTERED COUNTRY IDS
    // =========================
    const clusteredCountryIds = new Set<number>();
    const activeClusterIds = new Set<number>(
      this.allClustersList
        .filter((c: any) => c.status === 'InUseMarket' || c.status === 'Active')
        .map((c: any) => c.marketId)
    );

    this.allClustersList.forEach((cluster: any) => {

      // FIX: only exclude countries of ACTIVE clusters
      const isActiveCluster = cluster.status === 'InUseMarket' || cluster.status === 'Active';
      if (!isActiveCluster) { return; }

      (cluster.followerMarketIds || []).forEach((fId: number) => {
        const child = list.find((m: any) => m.marketId === fId);
        if (child && !child.isCluster && !child.isState) {
          clusteredCountryIds.add(fId);
        }
      });

      (cluster.fastAssessmentOrders || []).forEach((order: any) => {
        const child = list.find((m: any) => m.marketId === order.fallbackMarketId);
        if (child && !child.isCluster && !child.isState) {
          clusteredCountryIds.add(child.marketId);
        }
      });
    });

    list.forEach((country: any) => {
      if (country.isCluster || country.isState) { return; }

      const hasActiveParentCluster = (country.fastAssessmentOrders || []).some((order: any) => {
        return activeClusterIds.has(order.fallbackMarketId);
      });

      if (hasActiveParentCluster) {
        clusteredCountryIds.add(country.marketId);
      }
    });

    // =========================
    // COUNTRIES FOR STATE
    // =========================
    this.allCountriesForState = list.filter((m: any) => {
      return !m.isCluster && !m.isState && (m.status === 'InUseMarket' || m.status === 'Active');
    });

    // =========================
    // AVAILABLE COUNTRIES
    // =========================
    this.allCountriesList = list.filter((m: any) => {

      return (
        !m.isCluster &&
        !m.isState &&
        !clusteredCountryIds.has(m.marketId) &&
        (m.status === 'InUseMarket' || m.status === 'Active')
      );
    });
    this.masterCountriesList = [...this.allCountriesList];
    // let alreadyMappedCountries: any[] = [];

    // this.allClustersList.forEach((cluster: any) => {
    //   (cluster.countriesPartOf || []).forEach((c: any) => {
    //     alreadyMappedCountries.push(c);
    //   });
    // });
    // =========================
    // DROPDOWN OPTIONS
    // =========================
    this.enrichedClusterOptions =
      this.buildEnrichedClusterOptions(
        this.allClustersList,
      );

    console.log(
      'enrichedClusterOptions => ',
      this.enrichedClusterOptions,
    );
    this.updateFollowMarketOptions();
  }


  getDescendantIds(marketId: number): Set<number> {
    const result = new Set<number>();
    const queue = [marketId];

    while (queue.length > 0) {
      const current: any = queue.shift();

      const market = this.allMarketsList.find(
        (m: any) => m.marketId === current,
      );

      if (!market) {
        continue;
      }

      (market.followerMarketIds || []).forEach((fId: any) => {
        if (fId != null) {
          const id = parseInt(fId, 10);
          if (!result.has(id)) {
            result.add(id);
            queue.push(id);
          }
        }
      });

      (market.fastAssessmentOrders || []).forEach((order: any) => {
        if (order.fallbackMarketId != null) {
          const id = parseInt(order.fallbackMarketId, 10);
          const childMarket = this.allMarketsList.find((m: any) => m.marketId === id);
          if (childMarket && !childMarket.isCluster) {
            if (!result.has(id)) {
              result.add(id);
              queue.push(id);
            }
          }
        }
      });
    }

    return result;
  }

  getRecursiveChain(clusterCode: string, visited = new Set<string>()): Set<string> {
    const chain = new Set<string>();
    if (!clusterCode || visited.has(clusterCode)) {
      return chain;
    }
    visited.add(clusterCode);

    const cluster = this.allClustersList.find((c: any) => c.marketCode === clusterCode);
    if (!cluster) {
      return chain;
    }

    const parentOrder = (cluster.fastAssessmentOrders || [])
      .find((o: any) => this.allClustersList.some((c: any) => c.marketCode === o.fallbackMarketIsoCode));
    const parentClusterCode = parentOrder ? parentOrder.fallbackMarketIsoCode : null;

    let parentChain = new Set<string>();
    if (parentClusterCode) {
      parentChain = this.getRecursiveChain(parentClusterCode, visited);
    }

    chain.add(clusterCode);
    parentChain.forEach(code => chain.add(code));

    const clusterCodes = new Set(this.allClustersList.map((c: any) => c.marketCode));
    (cluster.fastAssessmentOrders || []).forEach((o: any) => {
      const code = o.fallbackMarketIsoCode;
      if (code && !clusterCodes.has(code)) {
        const market = this.allMarketsList.find((m: any) => m.marketCode === code);
        if (market && !market.isCluster && !market.isState) {
          if (!parentChain.has(code)) {
            chain.add(code);
          }
        }
      }
    });

    return chain;
  }

  mapResponseToRow(item: any) {
    const isCluster = !!(item.isCluster || item.IsCluster);
    const isState = !!(item.isState || item.IsState);
    const marketType = isCluster ? 'Cluster' : isState ? 'State' : 'Country';
    const marketId = parseInt(item.marketId || item.id || item.Id || item.MarketId, 10);
    const isoCode = item.isoCode || item.IsoCode || item.marketCode || '';
    const marketName = item.marketName || item.MarketName || '';
    const status = item.fAsTStatus || item.fastStatus || item.FastStatus || item.fasTStatus || item.FAsTStatus || item.faststatus || item.status || item.Status || '';
    const rawStatus = item.status || item.Status || '';

    const createdBy =
      item.createdByUserDisplayName ||
      item.CreatedByUserDisplayName ||
      item.createdByUserName ||
      item.CreatedByUserName ||
      item.createdByName ||
      item.CreatedByName ||
      item.createdBy ||
      item.CreatedBy ||
      item.createdByUserId ||
      item.CreatedByUserId ||
      '';

    const clusterCodes = new Set<string>(
      this.allClustersList.map((c: any) => c.marketCode)
    );

    let parentCluster: any = null;
    let parentCountry: any = null;
    if (!isCluster && !isState) {
      const firstClusterOrder = (item.fastAssessmentOrders || item.FastAssessmentOrders || []).find((o: any) =>
        clusterCodes.has(o.fallbackMarketIsoCode || o.FallbackMarketIsoCode)
      );
      if (firstClusterOrder) {
        parentCluster = this.allClustersList.find((c: any) =>
          ((firstClusterOrder.fallbackMarketId || firstClusterOrder.FallbackMarketId) != null && c.marketId === (firstClusterOrder.fallbackMarketId || firstClusterOrder.FallbackMarketId)) ||
          ((firstClusterOrder.fallbackMarketIsoCode || firstClusterOrder.FallbackMarketIsoCode) != null && c.marketCode === (firstClusterOrder.fallbackMarketIsoCode || firstClusterOrder.FallbackMarketIsoCode))
        ) || null;
      }
      if (!parentCluster) {
        parentCluster = this.allClustersList.find((c: any) =>
          (c.followerMarketIds || []).some((fId: any) => parseInt(fId, 10) === marketId) ||
          (c.fastAssessmentOrders || []).some((o: any) => (o.fallbackMarketId || o.FallbackMarketId) != null && parseInt(o.fallbackMarketId || o.FallbackMarketId, 10) === marketId)
        );
      }
    } else if (isState) {
      let pCountryId: number | null = null;
      if (item.parentCountryId != null) {
        pCountryId = parseInt(item.parentCountryId, 10);
      } else if (item.ParentCountryId != null) {
        pCountryId = parseInt(item.ParentCountryId, 10);
      } else if (item.parentCountry != null) {
        if (typeof item.parentCountry === 'object') {
          const pId = item.parentCountry.marketId || item.parentCountry.id || item.parentCountry.Id || item.parentCountry.MarketId;
          if (pId != null) {
            pCountryId = parseInt(pId, 10);
          }
        } else {
          pCountryId = parseInt(item.parentCountry, 10);
        }
      }

      if (pCountryId != null) {
        parentCountry = this.allMarketsList.find((m: any) => m.marketId === pCountryId);
      }
    }

    let fastOrderCodes: string[] = [];
    if (parentCluster) {
      fastOrderCodes = [parentCluster.assessmentOrder || parentCluster.marketCode];
    } else if (parentCountry) {
      fastOrderCodes = [parentCountry.assessmentOrder || parentCountry.marketCode];
    } else {
      const allFastCodes = Array.isArray(item.fastAssessmentOrders || item.FastAssessmentOrders)
        ? (item.fastAssessmentOrders || item.FastAssessmentOrders)
          .filter((o: any) => (o.fallbackMarketIsCluster || o.FallbackMarketIsCluster) === true || clusterCodes.has(o.fallbackMarketIsoCode || o.FallbackMarketIsoCode))
          .map((o: any) => o.fallbackMarketIsoCode || o.FallbackMarketIsoCode)
          .filter((x: any) => typeof x === 'string' && x !== isoCode)
        : (Array.isArray(item.fastAssessmentOrder || item.FastAssessmentOrder)
          ? (item.fastAssessmentOrder || item.FastAssessmentOrder).filter((x: any) => typeof x === 'string' && x !== isoCode)
          : []);
      fastOrderCodes = allFastCodes;
    }

    const assessmentOrder = fastOrderCodes.length > 0
      ? [isoCode, ...fastOrderCodes].join(' > ')
      : isoCode;

    // Filter out mapped countries from followerMarket display in row
    const mappedCountryIds: number[] = [];
    if (isCluster) {
      this.allMarketsList.forEach((m: any) => {
        if (!m.isCluster && !m.isState) {
          if (m.fastCodes && m.fastCodes[0] === isoCode) {
            mappedCountryIds.push(m.marketId);
          }
        }
      });
    }

    const rawFollowers = item.followerMarkets || item.FollowerMarkets || [];
    const filteredFollowers = rawFollowers.filter((f: any) => {
      const fId = typeof f === 'object' ? (f.followerMarketId || f.FollowerMarketId) : f;
      return fId != null && !mappedCountryIds.includes(parseInt(fId, 10));
    });

    const followerMarket = filteredFollowers
      .map((f: any) => {
        const fId = typeof f === 'object' ? (f.followerMarketId || f.FollowerMarketId) : f;
        if (fId == null) { return ''; }

        // Look up in allMarketsList to get the most accurate, up-to-date name
        const matched = this.allMarketsList.find((m: any) => parseInt(m.marketId, 10) === parseInt(fId, 10));
        if (matched) {
          return matched.marketName || matched.marketCode || '';
        }

        // Fallback to object properties if not found in list
        if (typeof f === 'object') {
          return f.followerMarketName || f.FollowerMarketName || f.followerMarketIsoCode || f.FollowerMarketIsoCode || '';
        }
        return '';
      })
      .filter((x: any) => x)
      .join(', ');

    const createdDateTime = (item.createdDate || item.CreatedDate)
      ? new Date(item.createdDate || item.CreatedDate).getTime()
      : null;

    const modifiedDateTime = (item.modifiedDate || item.ModifiedDate)
      ? new Date(item.modifiedDate || item.ModifiedDate).getTime()
      : null;

    const isModified =
      createdDateTime !== modifiedDateTime;

    let parentCountryId: number | null = null;
    if (isState) {
      if (item.parentCountryId != null) {
        parentCountryId = parseInt(item.parentCountryId, 10);
      } else if (item.ParentCountryId != null) {
        parentCountryId = parseInt(item.ParentCountryId, 10);
      } else if (item.parentCountry != null) {
        if (typeof item.parentCountry === 'object') {
          const pId = item.parentCountry.marketId || item.parentCountry.id || item.parentCountry.Id || item.parentCountry.MarketId;
          if (pId != null) {
            parentCountryId = parseInt(pId, 10);
          }
        } else {
          parentCountryId = parseInt(item.parentCountry, 10);
        }
      }
    }

    let parentCountryName = '';
    if (item.parentCountryName) {
      parentCountryName = item.parentCountryName;
    } else if (item.ParentCountryName) {
      parentCountryName = item.ParentCountryName;
    } else if (item.parentCountry && typeof item.parentCountry === 'object') {
      parentCountryName = item.parentCountry.marketName || item.parentCountry.MarketName || item.parentCountry.name || '';
    }

    const fastMappedCountries = (item.fastMappedCountries || item.FastMappedCountries || [])
      .map((c: any) => ({
        marketId: c.marketId != null ? parseInt(c.marketId, 10) : (c.MarketId != null ? parseInt(c.MarketId, 10) : null),
        marketName: c.marketName || c.MarketName || '',
        marketCode: c.isoCode || c.IsoCode || c.marketCode || c.MarketCode || ''
      }))
      .filter((c: any) => c.marketId != null);

    const prefMappedCountries = (item.prefMappedCountries || item.PrefMappedCountries || [])
      .map((c: any) => ({
        marketId: c.marketId != null ? parseInt(c.marketId, 10) : (c.MarketId != null ? parseInt(c.MarketId, 10) : null),
        marketName: c.marketName || c.MarketName || '',
        marketCode: c.isoCode || c.IsoCode || c.marketCode || c.MarketCode || ''
      }))
      .filter((c: any) => c.marketId != null);

    return {
      marketId: marketId,
      fastMappedCountries: fastMappedCountries,
      prefMappedCountries: prefMappedCountries,
      marketCode: isoCode,
      marketName: marketName,
      marketType: marketType,
      usageStatus: status === 'InUseMarket' ? 'Active' : 'Inactive',
      createdBy: createdBy,
      createdDate: (item.createdDate || item.CreatedDate)
        ? this.datePipe.transform(new Date(item.createdDate || item.CreatedDate), 'dd-MM-yyyy')
        : '',
      modifiedBy: isModified ? (item.modifiedByUserName || item.ModifiedByUserName || item.modifiedByName || item.ModifiedByName || item.modifiedBy || item.ModifiedBy || '') : '',
      modifiedDate: isModified ? ((item.modifiedDate || item.ModifiedDate)
        ? this.datePipe.transform(new Date(item.modifiedDate || item.ModifiedDate), 'dd-MM-yyyy')
        : '') : '',
      isActive: status === 'InUseMarket' ? '1' : '0',
      isCluster: isCluster,
      isState: isState,
      parentCountryId: parentCountryId,
      followerMarketIds: filteredFollowers.map((f: any) => {
        const id = typeof f === 'object' ? (f.followerMarketId || f.FollowerMarketId) : f;
        return id != null ? parseInt(id, 10) : null;
      }).filter((id: any) => id != null),
      followerMarket: followerMarket,
      parentCountryName: parentCountryName,
      prefAssessmentOrders: item.prefAssessmentOrders || item.PrefAssessmentOrders || [],
      assessmentOrder: assessmentOrder,
      fastAssessmentOrder: fastOrderCodes.join(' > '),
      fastAssessmentOrders: item.fastAssessmentOrders || item.FastAssessmentOrders || [],
      isOneUnilever: !!(item.isOneUnilever || item.IsOneUnilever),
      partOf1UL: (item.isOneUnilever || item.IsOneUnilever) ? 'Yes' : 'No',
      rawCreatedDate: item.createdDate || item.CreatedDate || '',
      rawModifiedDate: item.modifiedDate || item.ModifiedDate || '',
      rawStatus: rawStatus
    };
  }

  openAddPopup() {
    this.resetPopUpValues();
    this.selectedStatus = '1';
    this.openPopUp = true;
  }

  async openEditPopup(table: any) {
    const rowData = this.selectedTableRow;

    if (!rowData) {
      return;
    }

    const marketId = rowData.marketId || null;

    const apiUrl = this.marketApiBase + '/' + marketId;
    try {
      this.loadingMessage = 'Fetching Market Details...';
      this.loading = true;
      const response: any = await this.apiService.getData(apiUrl).toPromise();
      this.loading = false;

      const matchedMarket = (this.initialRawResponse || []).find((m: any) => parseInt(m.marketId, 10) === parseInt(marketId, 10));
      if (matchedMarket) {
        response.fastAssessmentOrders = matchedMarket.fastAssessmentOrders || [];
        response.fastAssessmentOrder = matchedMarket.fastAssessmentOrder || [];
        response.followerMarkets = matchedMarket.followerMarkets || [];
        response.followerMarketIds = matchedMarket.followerMarketIds || [];
      }

      this.populateEditPopup(response);
    } catch (err) {

      console.error(err);
    }
  }

  populateEditPopup(response: any) {
    const rowData = this.mapResponseToRow(response);
    this.selectedRowData = rowData;
    this.selectedMarketType = rowData.marketType;
    this.editPopup = true;
    this.cycleError = '';
    setTimeout(() => {
      this.selectedMarketName = rowData.marketName;
      this.selectedMarketCode = rowData.marketCode;
      this.selectedStatus = rowData.isActive;
      this.selectedPartOf1UL = rowData.partOf1UL;

      const parentCluster = this.getParentClusterOf(rowData.marketId);

      const firstClusterOrder = (rowData.fastAssessmentOrders || [])
        .find((o: any) =>
          o.fallbackMarketIsoCode !== rowData.marketCode &&
          this.allClustersList.some((c: any) =>
            c.marketCode === o.fallbackMarketIsoCode
          )
        );

      this.selectedPartOfCluster = firstClusterOrder
        ? this.enrichedClusterOptions.find((x: any) =>
          x.marketCode === firstClusterOrder.fallbackMarketIsoCode
        ) || null
        : (parentCluster
          ? this.enrichedClusterOptions.find((x: any) =>
            x.marketId === parentCluster.marketId
          ) || null
          : null);

      this.initialSelectedPartOfClusterCode = this.selectedPartOfCluster ? this.selectedPartOfCluster.marketCode : null;
      this.originalDirectParentClusterCode = parentCluster ? parentCluster.marketCode : null;

      if (rowData.marketType === 'Cluster') {
        // Use allClustersList instead of enrichedClusterOptions
        const clusterCodes = new Set(
          this.allClustersList.map((c: any) => c.marketCode)
        );

        const parentClusterCode = parentCluster ? parentCluster.marketCode : null;
        const parentFallbackCodes = parentClusterCode
          ? this.getRecursiveChain(parentClusterCode)
          : new Set<string>();

        const backendMappedCodes = (rowData.fastMappedCountries || [])
          .map((c: any) => c.marketCode)
          .filter((x: any) => x);

        const rawMappedCountryCodes = backendMappedCodes.length > 0
          ? backendMappedCodes
          : this.allMarketsList
            .filter((m: any) => {
              if (m.isCluster || m.isState) { return false; }
              const pointsToThisCluster = (m.fastAssessmentOrders || []).some((o: any) =>
                (o.fallbackMarketId != null && parseInt(o.fallbackMarketId, 10) === rowData.marketId) ||
                (o.fallbackMarketIsoCode != null && o.fallbackMarketIsoCode === rowData.marketCode)
              );
              return pointsToThisCluster;
            })
            .map((m: any) => m.marketCode);

        const mappedCountryCodes = rawMappedCountryCodes.filter((code: string) => {
          const country = this.allMarketsList.find((m: any) => m.marketCode === code);
          if (!country) { return false; }
          return country.fastCodes && country.fastCodes[0] === rowData.marketCode;
        });

        const followerIds = (rowData.followerMarketIds || []).map((id: any) => parseInt(id, 10)).filter((id: number) => !isNaN(id));
        this.selectedFollowMarket = this.allMarketsList.filter((m: any) =>
          followerIds.includes(parseInt(m.marketId, 10)) &&
          !mappedCountryCodes.includes(m.marketCode)
        );

        const thisClusterCountries = this.allMarketsList.filter((m: any) =>
          !m.isCluster && !m.isState && mappedCountryCodes.includes(m.marketCode)
        );

        // Build allCountriesForEdit - include all available countries
        const combined: any[] = [...this.allCountriesList];
        thisClusterCountries.forEach((c: any) => {
          if (!combined.find((x: any) => x.marketId === c.marketId)) {
            combined.push(c);
          }
        });

        this.allCountriesForEdit = combined;
        this.masterCountriesForEdit = [...this.allCountriesForEdit];

        this.selectedCountries = this.allCountriesForEdit.filter((m: any) =>
          mappedCountryCodes.includes(m.marketCode)
        );
        this.updateFollowMarketOptions();

        const descendants = this.getDescendantIds(rowData.marketId);
        const validClusters = this.allClustersList.filter((c: any) =>
          c.marketId !== rowData.marketId && !descendants.has(c.marketId)
        );
        this.enrichedClusterOptions = this.buildEnrichedClusterOptions(validClusters);

      } else if (rowData.marketType === 'Country') {
        this.selectedCountries = [];
        const followerIds = (rowData.followerMarketIds || []).map((id: any) => parseInt(id, 10)).filter((id: number) => !isNaN(id));
        this.selectedFollowMarket = this.allMarketsList.filter((m: any) =>
          followerIds.includes(parseInt(m.marketId, 10))
        );
        this.enrichedClusterOptions = this.buildEnrichedClusterOptions(this.allClustersList);

      } else if (rowData.marketType === 'State') {
        this.selectedCountries = [];
        const followerIds = (rowData.followerMarketIds || []).map((id: any) => parseInt(id, 10)).filter((id: number) => !isNaN(id));
        this.selectedFollowMarket = this.allMarketsList.filter((m: any) =>
          followerIds.includes(parseInt(m.marketId, 10))
        );

        this.allCountriesForState = this.allMarketsList.filter((m: any) => {
          if (m.isCluster || m.isState) { return false; }
          const isActive = m.status === 'InUseMarket' || m.status === 'Active';
          const isCurrentlySelected = rowData.parentCountryId != null && m.marketId === rowData.parentCountryId;
          return isActive || isCurrentlySelected;
        });

        const foundCountry = this.allCountriesForState.find((c: any) => c.marketId === rowData.parentCountryId);
        this.selectedCountry = foundCountry || null;
        this.initialSelectedCountryId = this.selectedCountry ? this.selectedCountry.marketId : null;
        this.enrichedClusterOptions = this.buildEnrichedClusterOptions(this.allClustersList);
        this.onCountryToMapChange();

      }

      this.computedAssessmentOrder = rowData.fastAssessmentOrder
        ? `${rowData.marketCode} > ${rowData.fastAssessmentOrder}`
        : rowData.marketCode;

      this.selectedPrefOrder = (rowData.prefAssessmentOrders || []).map(
        (o: any) => o.fallbackMarketIsoCode
      );

      if (this.selectedMarketType === 'State') {
        this.onCountryToMapChange();
      } else {
        this.onPartOfClusterChange();
      }
      this.enableOrDisable();
      this.updateFollowMarketOptions();
      this.initialSelectedFollowerMarketIds = (this.selectedFollowMarket || []).map(m => m.marketId);
      this.initialSelectedCountryIds = (this.selectedCountries || []).map(c => c.marketId);
      this.updateEditSubmitState();
    }, 0);
  }

  isMarketCodeValid(): boolean {
    const code = this.selectedMarketCode ? this.selectedMarketCode.trim() : '';

    if (code.length === 0) {
      return true;
    }

    return /^[A-Za-z]{3}$/.test(code);
  }

  isMarketNameFormatInvalid(name: string): boolean {
    if (!name) { return false; }
    return !/^[A-Za-z0-9\/\(\)\-& ]*$/.test(name);
  }

  isMarketNameValid(name: string): boolean {
    const trimmedName = name ? name.trim() : '';

    if (!trimmedName) {
      return false;
    }

    if (trimmedName.length < 2) {
      return false;
    }

    if (trimmedName.length > 120) {
      return false;
    }

    if (!/[A-Za-z]/.test(trimmedName)) {
      return false;
    }

    if (/^\d+$/.test(trimmedName)) {
      return false;
    }

    if (/^[-/()&\s]+$/.test(trimmedName)) {
      return false;
    }

    if (/[-/()&]{3,}/.test(trimmedName) || /([A-Za-z0-9])\1{5,}/.test(trimmedName)) {
      return false;
    }

    if (/\s{2,}/.test(trimmedName)) {
      return false;
    }

    const hasParentheses = /[()]/.test(trimmedName);
    const isBalancedParentheses = !hasParentheses || this.isBalancedParentheses(trimmedName);
    if (!isBalancedParentheses) {
      return false;
    }

    if (!/^[A-Za-z0-9]/.test(trimmedName) || !/[A-Za-z0-9)]$/.test(trimmedName)) {
      return false;
    }

    if (/[-/()&]{2,}/.test(trimmedName)) {
      return false;
    }

    if (/([A-Za-z0-9])\1{2,}/.test(trimmedName)) {
      return false;
    }

    return true;
  }

  private isBalancedParentheses(value: string): boolean {
    let balance = 0;
    for (const char of value) {
      if (char === '(') {
        balance++;
      } else if (char === ')') {
        balance--;
        if (balance < 0) {
          return false;
        }
      }
    }
    return balance === 0;
  }

  onMarketCodeChange(value: string) {
    const upper = value ? value.trim().toUpperCase() : '';
    this.selectedMarketCode = upper;
    if (this.selectedMarketType === 'State') {
      this.onCountryToMapChange();
    } else {
      this.onPartOfClusterChange();
    }
    this.updateFollowMarketOptions();
  }
  onMarketNameChange(value: string) {
    this.selectedMarketName = value ? value : '';
    this.enableOrDisable();
  }
  onMarketTypeChange() {
    this.selectedCountry = null;
    this.selectedCountries = [];
    this.selectedFollowMarket = [];
    this.selectedPartOfCluster = null;
    this.selectedStatus = this.editPopup ? null : '1';
    this.selectedPartOf1UL = null;
    this.cycleError = '';
    this.selectedPrefOrder = [];
    this.selectedFastOrder = [];

    this.computedAssessmentOrder = '';
    this.clusterCircularError = '';

    this.enrichedClusterOptions = this.buildEnrichedClusterOptions(
      this.allClustersList,
    );

    this.enableOrDisable();
    this.updateFollowMarketOptions();
  }

  clearMarketType() {
    this.selectedMarketType = null;
    this.onMarketTypeChange();
  }

  onCountriesToMapChange() {
    if (this.editPopup) {
      this.updateEditSubmitState();
    } else {
      this.enableOrDisable();
    }
    if (!this.isCountriesPanelOpen) {
      this.updateFollowMarketOptions();
    }
  }

  clearSelectedCountries() {
    this.selectedCountries = [];
    if (this.editPopup) {
      this.updateEditSubmitState();
    } else {
      this.enableOrDisable();
    }
    this.updateFollowMarketOptions();
  }

  clearFollowerMarket() {
    this.selectedFollowMarket = [];
    if (this.editPopup) {
      this.updateEditSubmitState();
    } else {
      this.enableOrDisable();
    }
    this.updateFollowMarketOptions();
  }

  getParentClusterOf(marketId: number): any | null {
    const market = this.allMarketsList.find((m: any) => m.marketId === marketId);
    if (!market) { return null; }

    if (market.isCluster) {
      return (
        this.allClustersList.find((c: any) =>
          c.marketId !== marketId && (
            (c.followerMarketIds || []).map((id: any) => parseInt(id, 10)).includes(marketId) ||
            (market.fastAssessmentOrders || []).some((o: any) => o.fallbackMarketId != null && parseInt(o.fallbackMarketId, 10) === c.marketId)
          )
        ) || null
      );
    } else {
      const firstClusterOrder = (market.fastAssessmentOrders || []).find((o: any) =>
        this.allClustersList.some((c: any) => c.marketId === o.fallbackMarketId || c.marketCode === o.fallbackMarketIsoCode)
      );
      if (firstClusterOrder) {
        return this.allClustersList.find((c: any) =>
          (firstClusterOrder.fallbackMarketId != null && c.marketId === firstClusterOrder.fallbackMarketId) ||
          (firstClusterOrder.fallbackMarketIsoCode != null && c.marketCode === firstClusterOrder.fallbackMarketIsoCode)
        ) || null;
      }

      return (
        this.allClustersList.find((c: any) =>
          c.marketId !== marketId && (
            (c.followerMarketIds || []).map((id: any) => parseInt(id, 10)).includes(marketId) ||
            (c.fastAssessmentOrders || []).some((o: any) => o.fallbackMarketId != null && parseInt(o.fallbackMarketId, 10) === marketId)
          )
        ) || null
      );
    }
  }

  validateMarketName() {
    const trimmedName = this.selectedMarketName ? this.selectedMarketName.trim() : '';

    if (!trimmedName) {
      this.marketNameValidationError = '';
      return true;
    }

    if (this.isMarketNameFormatInvalid(trimmedName)) {
      this.marketNameValidationError = 'Please enter a valid market name';
      return false;
    }

    if (!this.isMarketNameValid(trimmedName)) {
      this.marketNameValidationError = 'Please enter a valid market name';
      return false;
    }

    this.marketNameValidationError = '';
    return true;
  }

  validateDuplicates() {
    if (this.editPopup) {
      const upperEdit = this.selectedMarketCode ? this.selectedMarketCode.trim().toUpperCase() : '';
      const editingCode = this.selectedRowData ? (this.selectedRowData.marketCode || '').toUpperCase() : '';
      const wasInactive = this.selectedRowData && this.selectedRowData.isActive === '0';

      let duplicateIso = false;
      let diffTypeIso = false;
      let isOtherInactive = false;
      if (upperEdit) {
        if (upperEdit !== editingCode) {
          const otherExisting = this.allMarketsList.find((m: any) =>
            m.marketId !== (this.selectedRowData ? this.selectedRowData.marketId : null) &&
            m.marketCode && m.marketCode.trim().toUpperCase() === upperEdit
          );
          if (otherExisting) {
            let otherType = 'Country';
            if (otherExisting.isCluster) { otherType = 'Cluster'; } else if (otherExisting.isState) { otherType = 'State'; }

            if (otherType !== this.selectedMarketType) {
              diffTypeIso = true;
            } else {
              const isOtherActive = otherExisting.status === 'InUseMarket' || otherExisting.status === 'Active';
              if (isOtherActive) {
                duplicateIso = true;
              } else {
                isOtherInactive = true;
              }
            }
          }
        } else if (wasInactive && this.selectedStatus === '1') {
          duplicateIso = this.allMarketsList.some((m: any) =>
            m.marketId !== this.selectedRowData.marketId &&
            m.marketCode && m.marketCode.trim().toUpperCase() === upperEdit &&
            (m.status === 'InUseMarket' || m.status === 'Active')
          );
          if (!duplicateIso) {
            const otherExisting = this.allMarketsList.find((m: any) =>
              m.marketId !== this.selectedRowData.marketId &&
              m.marketCode && m.marketCode.trim().toUpperCase() === upperEdit
            );
            if (otherExisting) {
              let otherType = 'Country';
              if (otherExisting.isCluster) { otherType = 'Cluster'; } else if (otherExisting.isState) { otherType = 'State'; }

              if (otherType !== this.selectedMarketType) {
                diffTypeIso = true;
              }
            }
          }
        }
      }

      if (duplicateIso) {
        this.isoCodeDuplicateError = 'This ISO code is already in use';
      } else if (isOtherInactive) {
        this.isoCodeDuplicateError = 'This ISO code exists for an inactive market. Please make that active.';
      } else if (diffTypeIso) {
        this.isoCodeDuplicateError = 'This ISO code already exists with a different market type';
      } else {
        this.isoCodeDuplicateError = '';
      }

      const trimmedNameEdit = this.selectedMarketName ? this.selectedMarketName.trim() : '';
      const editingName = this.selectedRowData ? (this.selectedRowData.marketName || '').trim() : '';

      let duplicateName = false;
      let isNameOtherInactive = false;
      const formatInvalid = this.isMarketNameFormatInvalid(trimmedNameEdit);
      const editNameValidationResult = this.validateMarketName();

      if (formatInvalid || !editNameValidationResult) {
        this.nameDuplicateError = 'Please enter a valid market name';
      } else if (trimmedNameEdit) {
        const trimmedNameEditLower = trimmedNameEdit.toLowerCase();
        const editingNameLower = editingName.toLowerCase();
        if (trimmedNameEditLower !== editingNameLower) {
          const otherExisting = this.allMarketsList.find((m: any) =>
            m.marketId !== (this.selectedRowData ? this.selectedRowData.marketId : null) &&
            m.marketName && m.marketName.trim().toLowerCase() === trimmedNameEditLower
          );
          if (otherExisting) {
            const isOtherActive = otherExisting.status === 'InUseMarket' || otherExisting.status === 'Active';
            if (isOtherActive) {
              duplicateName = true;
            } else {
              isNameOtherInactive = true;
            }
          }
        } else if (wasInactive && this.selectedStatus === '1') {
          duplicateName = this.allMarketsList.some((m: any) =>
            m.marketId !== this.selectedRowData.marketId &&
            m.marketName && m.marketName.trim().toLowerCase() === trimmedNameEditLower &&
            (m.status === 'InUseMarket' || m.status === 'Active')
          );
        }
      }

      if (formatInvalid) {
        // already set above
      } else if (duplicateName) {
        this.nameDuplicateError = 'This market name is already in use';
      } else if (isNameOtherInactive) {
        this.nameDuplicateError = 'This market name exists for an inactive market. Please make that active.';
      } else {
        this.nameDuplicateError = '';
      }
      return;
    }

    // Adding a new market:
    const upper = this.selectedMarketCode ? this.selectedMarketCode.trim().toUpperCase() : '';
    const isCodeValid = upper.length === 3 && /^[A-Za-z]{3}$/.test(upper);
    if (isCodeValid) {
      const existing = this.allMarketsList.find((m: any) => m.marketCode && m.marketCode.trim().toUpperCase() === upper);
      if (existing) {
        let existingType = 'Country';
        if (existing.isCluster) { existingType = 'Cluster'; } else if (existing.isState) { existingType = 'State'; }

        if (existingType !== this.selectedMarketType) {
          this.isoCodeDuplicateError = 'This ISO code already exists with a different market type';
        } else {
          const isActive = existing.status === 'InUseMarket' || existing.status === 'Active';
          if (isActive) {
            this.isoCodeDuplicateError = 'This ISO code is already in use';
          } else {
            this.isoCodeDuplicateError = 'This ISO code exists for an inactive market. Please make that active.';
          }
        }
      } else {
        this.isoCodeDuplicateError = '';
      }
    } else {
      this.isoCodeDuplicateError = '';
    }

    const trimmedName = this.selectedMarketName ? this.selectedMarketName.trim() : '';
    const addNameValidationResult = this.validateMarketName();
    if (this.isMarketNameFormatInvalid(trimmedName) || !addNameValidationResult) {
      this.nameDuplicateError = 'Please enter a valid market name';
    } else if (trimmedName.length > 0) {
      const trimmedNameLower = trimmedName.toLowerCase();
      const existing = this.allMarketsList.find((m: any) => m.marketName && m.marketName.trim().toLowerCase() === trimmedNameLower);
      if (existing) {
        let existingType = 'Country';
        if (existing.isCluster) {
          existingType = 'Cluster';
        } else if (existing.isState) {
          existingType = 'State';
        }

        if (existingType !== this.selectedMarketType) {
          this.nameDuplicateError = 'This market name already exists with a different market type';
        } else {
          const isActive = existing.status === 'InUseMarket' || existing.status === 'Active';
          if (isActive) {
            this.nameDuplicateError = 'This market name is already in use';
          } else {
            this.nameDuplicateError = 'This market name exists for an inactive market. Please make that active.';
          }
        }
      } else {
        this.nameDuplicateError = '';
      }
    } else {
      this.nameDuplicateError = '';
    }
  }

  enableOrDisable() {
    this.validateDuplicates();

    const nameOk =
      !!this.selectedMarketName && this.selectedMarketName.trim().length > 0 && this.validateMarketName();

    const typeOk = !!this.selectedMarketType;

    let codeOk = false;

    if (this.editPopup) {
      codeOk = true;
    } else {
      const code = this.selectedMarketCode
        ? this.selectedMarketCode.trim()
        : '';

      codeOk = code.length === 3 && /^[A-Za-z]{3}$/.test(code);
    }

    const noCircular = !this.clusterCircularError;
    const noDuplicateIso = !this.isoCodeDuplicateError;
    const noDuplicateName = !this.nameDuplicateError && !this.marketNameValidationError;
    const noCycle = !this.cycleError;

    if (!nameOk || !typeOk || !codeOk || !noCircular || !noDuplicateIso || !noDuplicateName || !noCycle) {
      this.disableSubmitInAdd = true;
      return;
    }

    let typeSpecificOk = false;

    if (this.selectedMarketType === 'Country') {
      typeSpecificOk = !!this.selectedStatus && !!this.selectedPartOf1UL;
    } else if (this.selectedMarketType === 'Cluster') {
      typeSpecificOk =
        !!this.selectedStatus && !!this.selectedPartOf1UL; // a
    } else if (this.selectedMarketType === 'State') {
      typeSpecificOk = !!this.selectedCountry && !!this.selectedStatus;
      if (this.isParentCountryInactive() && this.selectedStatus === '1') {
        typeSpecificOk = false;
      }
    }

    this.disableSubmitInAdd = !typeSpecificOk;
    // this.cdr.detectChanges();
  }

  buildApiPayload() {
    const isCluster = this.selectedMarketType === 'Cluster';
    const isState = this.selectedMarketType === 'State';
    const isActive = this.selectedStatus === '1';
    const isOneUL = this.selectedPartOf1UL === 'Yes';

    const toId = (val: any): number | null => {
      if (val == null) {
        return null;
      }

      if (typeof val === 'object') {
        return val.marketId != null ? parseInt(val.marketId, 10) : null;
      }

      return parseInt(val, 10);
    };

    const followerMarketIds = (this.selectedFollowMarket || []).map(toId).filter((id: any) => id != null);

    const parentCountryId = isState ? toId(this.selectedCountry) : null;
    let computedAssessmentOrderCodesArr: string[] = [];

    if (isState) {
      const parentCountry = this.allMarketsList.find((m: any) => m.marketId === parentCountryId);
      if (parentCountry && parentCountry.marketCode) {
        computedAssessmentOrderCodesArr = [parentCountry.marketCode.trim().toUpperCase()];
      }
    } else {
      computedAssessmentOrderCodesArr = this.computedAssessmentOrderCodes.length > 0
        ? [this.computedAssessmentOrderCodes[0].split('>').map(x => x.trim())[0]]
        : [];

      const currentClusterCode = this.selectedPartOfCluster
        ? (typeof this.selectedPartOfCluster === 'object' ? this.selectedPartOfCluster.marketCode : this.selectedPartOfCluster)
        : null;

      if (this.editPopup && currentClusterCode === this.initialSelectedPartOfClusterCode) {
        computedAssessmentOrderCodesArr = this.originalDirectParentClusterCode ? [this.originalDirectParentClusterCode] : [];
      }
    }

    const selfCode = this.selectedMarketCode ? this.selectedMarketCode.trim().toUpperCase() : '';
    let fastAssessmentOrder = selfCode ? [selfCode].concat(computedAssessmentOrderCodesArr) : computedAssessmentOrderCodesArr;
    const prefAssessmentOrder: string[] = [];

    if (isCluster) {
      const countryCodes = (this.selectedCountries || [])
        .map((c: any) => typeof c === 'object' ? c.marketCode : c)
        .filter((code: any) => code);

      fastAssessmentOrder = (selfCode ? [selfCode] : []).concat(computedAssessmentOrderCodesArr).concat(countryCodes);
    }

    const originalStatus = (this.editPopup && this.selectedRowData)
      ? (this.selectedRowData.rawStatus || 'RetiredMarket')
      : (isActive ? 'InUseMarket' : 'RetiredMarket');

    return {
      IsoCode: this.selectedMarketCode
        ? this.selectedMarketCode.trim().toUpperCase()
        : '',

      marketName: this.selectedMarketName,

      Status: originalStatus,
      FAsTStatus: isActive ? 'InUseMarket' : 'RetiredMarket',

      IsCluster: isCluster,
      IsState: isState,

      ParentCountryId: parentCountryId,

      IsOneUnilever: isOneUL,
      OneUnileverName: isOneUL ? '1 UL' : null,

      FollowerMarketIds: followerMarketIds,

      PrefAssessmentOrder: prefAssessmentOrder,
      FastAssessmentOrder: fastAssessmentOrder,
    };
  }

  submitPopUpValuesAdd() {
    if (this.disableSubmitInAdd) {
      return;
    }

    const payload = this.buildApiPayload();
    this.loading = true;
    this.loadingMessage = 'Saving Market...';
    this.isSubmitting = true;

    this.apiService.postData(this.marketApiBase, payload).subscribe(
      () => {
        this.isSubmitting = false;
        this.loading = false;
        this.showAlert('success', 'Success', 'Market added successfully', () => {
          this.ngOnInit();
          this.resetPopUpValues();
        });

        this.ngOnInit();
        this.resetPopUpValues();
      },

      (err) => {
        this.isSubmitting = false;
        this.loading = false;
        const msg = this.extractErrorMessage(err);

        this.showAlert('error', 'Error', msg, () => {
          this.ngOnInit();
          this.resetPopUpValues();
        });
      },
    );
  }

  submitPopUpValuesEdit() {
    if (this.disableSubmitInEdit) { return; }

    if (!this.hasChanges()) {
      this.showAlert('error', 'No Changes', 'No changes were made to the market. Please modify at least one field before saving.');
      return;
    }

    const payload = this.buildApiPayload();
    const id = this.selectedRowData.marketId;
    this.loadingMessage = 'Updating Market...';
    this.loading = true;
    this.isSubmitting = true;

    this.apiService.putApiData(this.marketApiBase + '/' + id, payload).subscribe(
      () => {
        this.finalizeUpdateSuccess();
      },
      (err) => {
        this.isSubmitting = false;
        this.loading = false;
        const msg = this.extractErrorMessage(err);
        this.showAlert('error', 'Error', msg, () => {
          this.ngOnInit();
          this.resetPopUpValues();
        });
      }
    );
  }

  finalizeUpdateSuccess() {
    this.isSubmitting = false;
    this.loading = false;
    this.showAlert('success', 'Success', 'Market updated successfully', () => {
      this.ngOnInit();
      this.resetPopUpValues();
    });
    this.ngOnInit();
    this.resetPopUpValues();
    this.buttonSelection = false;
  }

  customSort(event: any) {
    event.data.sort((a: any, b: any) => {
      const v1 = a[event.field];
      const v2 = b[event.field];

      if (v1 == null && v2 == null) { return 0; }
      if (v1 == null) { return -1 * event.order; }
      if (v2 == null) { return 1 * event.order; }

      // ✅ Use raw ISO date for sorting
      if (event.field === 'createdDate') {
        const d1 = new Date(a.rawCreatedDate).getTime();
        const d2 = new Date(b.rawCreatedDate).getTime();
        return (d1 - d2) * event.order;
      }

      if (event.field === 'modifiedDate') {
        const d1 = new Date(a.rawModifiedDate || 0).getTime();
        const d2 = new Date(b.rawModifiedDate || 0).getTime();
        return (d1 - d2) * event.order;
      }

      return v1.toString().localeCompare(v2.toString()) * event.order;
    });
  }

  onFilterInput(field: string) {
    this.currentFilteredField = field;
  }

  onFilter(event: any) {
    this.selectedTableRow = null;
    this.selectedRowData = null;
    this.buttonSelection = false;

    const activeFilters = event.filters ? Object.keys(event.filters).filter(key => {
      const filter = event.filters[key];
      if (Array.isArray(filter)) {
        return filter.some(f => f.value !== null && f.value !== undefined && String(f.value).trim() !== '');
      }
      return filter && filter.value !== null && filter.value !== undefined && String(filter.value).trim() !== '';
    }) : [];

    const hasActiveFilters = activeFilters.length > 0;

    if (hasActiveFilters) {
      const rows = event.filteredValue || [];
      const sortKey = activeFilters.includes(this.currentFilteredField) ? this.currentFilteredField : activeFilters[0];

      const filterObj = event.filters[sortKey];
      let query = '';
      if (filterObj) {
        if (Array.isArray(filterObj)) {
          const firstVal = filterObj.find(f => f.value !== null && f.value !== undefined);
          query = firstVal ? String(firstVal.value).trim().toLowerCase() : '';
        } else if (filterObj.value !== null && filterObj.value !== undefined) {
          query = String(filterObj.value).trim().toLowerCase();
        }
      }

      rows.sort((a: any, b: any) => {
        const val1 = a[sortKey] != null ? String(a[sortKey]).trim().toLowerCase() : '';
        const val2 = b[sortKey] != null ? String(b[sortKey]).trim().toLowerCase() : '';

        if (query) {
          const starts1 = val1.startsWith(query);
          const starts2 = val2.startsWith(query);
          if (starts1 && !starts2) {
            return -1;
          }
          if (!starts1 && starts2) {
            return 1;
          }
        }

        return val1.localeCompare(val2);
      });
      this.filteredRows = rows;
    } else {
      this.filteredRows = [];
    }
    this.cdr.detectChanges();
  }

  selectRow(table: any) {
    this.buttonSelection = !!this.selectedTableRow;
  }

  clearAllFilters(table: any) {
    this.selectedTableRow = null;
    this.selectedRowData = null;
    this.buttonSelection = false;

    table.filters = {};
    table.filteredValue = null;
    table._filter();

    this.filteredRows = [];

    this.marketMasterColumns.forEach((col: any) => {
      const input = document.getElementById(col.field + '_val') as HTMLInputElement;
      if (input) {
        input.value = '';
      }
    });
    this.cdr.detectChanges();
  }

  showExportDialog() {
    this.exportDialog = true;
  }

  resetPopUpValues() {
    this.openPopUp = false;
    this.editPopup = false;
    this.exportDialog = false;
    this.disableSubmitInEdit = true;
    this.nameDuplicateError = '';
    this.selectedMarketName = '';
    this.selectedMarketCode = '';
    this.selectedMarketType = null;

    this.selectedCountry = null;
    this.selectedCountries = [];
    this.selectedFollowMarket = [];
    this.selectedPartOfCluster = null;
    this.selectedStatus = null;
    this.selectedPartOf1UL = null;
    this.cycleError = '';
    this.selectedPrefOrder = [];
    this.selectedFastOrder = [];

    this.disableSubmitInAdd = true;
    this.isSubmitting = false;

    this.computedAssessmentOrder = '';
    this.computedAssessmentOrderCodes = [];

    this.clusterCircularError = '';
    this.isoCodeDuplicateError = '';

    this.allCountriesForEdit = [];

    this.allCountriesForState = this.allMarketsList.filter((m: any) => {
      return !m.isCluster && !m.isState && (m.status === 'InUseMarket' || m.status === 'Active');
    });

    this.initialSelectedPartOfClusterCode = null;
    this.originalDirectParentClusterCode = null;
    this.initialSelectedCountryId = null;
    this.initialSelectedFollowerMarketIds = [];
    this.initialSelectedCountryIds = [];

    this.enrichedClusterOptions = this.buildEnrichedClusterOptions(
      this.allClustersList,
    );
    this.updateFollowMarketOptions();
  }



  buildEnrichedClusterOptions(clusters: any[]): any[] {
    return clusters.map((c: any) => ({
      ...c,
      displayLabel: c.assessmentOrder || c.marketCode,
    }));
  }

  onPartOfClusterChange(dropdown?: any, isUserAction = false) {
    if (dropdown) {
      dropdown.hide();
    }
    this.clusterCircularError = '';
    this.cycleError = '';
    this.computedAssessmentOrderCodes = [];

    const execute = () => {
      if (!this.selectedPartOfCluster) {
        this.computedAssessmentOrder = this.selectedMarketCode;
        if (this.editPopup) {
          this.updateEditSubmitState();
        } else {
          this.enableOrDisable();
        }
        this.updateFollowMarketOptions();
        return;
      }

      const selectedId =
        typeof this.selectedPartOfCluster === 'object'
          ? this.selectedPartOfCluster.marketId
          : this.selectedPartOfCluster;



      const visited = new Set<number>();
      const chain: string[] = [];
      let currentId: number | null = selectedId;
      while (currentId != null) {
        if (visited.has(currentId)) {
          this.clusterCircularError = 'Circular hierarchy detected';
          this.disableSubmitInAdd = true;
          this.updateFollowMarketOptions();
          return;
        }

        visited.add(currentId);

        const market = this.allMarketsList.find((m: any) => m.marketId === currentId);
        if (!market) { break; }

        chain.push(market.marketCode);

        // walk UP to parent cluster using our non-circular helper
        const parentCluster = this.getParentClusterOf(currentId);

        currentId = parentCluster ? parentCluster.marketId : null;
      }
      this.computedAssessmentOrderCodes = chain;
      const fullChain = [this.selectedMarketCode].concat(chain);
      const chainStr = chain.join(' > ');
      if (this.selectedMarketCode && chainStr.includes(this.selectedMarketCode)) {
        this.cycleError = 'This selection creates a cycle with the current market';
        this.disableSubmitInAdd = true;
        this.updateFollowMarketOptions();
        return;
      }

      this.computedAssessmentOrder = fullChain.join(' > ');
      this.enableOrDisable();
      this.updateEditSubmitState();
      this.updateFollowMarketOptions();
    };

    if (isUserAction) {
      setTimeout(execute, 0);
    } else {
      execute();
    }
  }

  onCountryToMapChange(dropdown?: any, isUserAction = false) {
    if (dropdown) {
      dropdown.hide();
    }
    this.computedAssessmentOrder = '';

    const execute = () => {
      const countryId = typeof this.selectedCountry === 'object'
        ? (this.selectedCountry ? this.selectedCountry.marketId : null)
        : this.selectedCountry;

      if (!countryId) {
        this.computedAssessmentOrder = this.selectedMarketCode || '';
        if (this.editPopup) {
          this.updateEditSubmitState();
        } else {
          this.enableOrDisable();
        }
        this.updateFollowMarketOptions();
        return;
      }

      const parentCountry = this.allMarketsList.find((m: any) => m.marketId === parseInt(countryId, 10));
      if (parentCountry) {
        const parentOrder = parentCountry.assessmentOrder || parentCountry.marketCode;
        this.computedAssessmentOrder = [this.selectedMarketCode || '', parentOrder].join(' > ');
      } else {
        this.computedAssessmentOrder = this.selectedMarketCode || '';
      }

      if (this.editPopup) {
        this.updateEditSubmitState();
      } else {
        this.enableOrDisable();
      }
      this.updateFollowMarketOptions();
    };

    if (isUserAction) {
      setTimeout(execute, 0);
    } else {
      execute();
    }
  }

  private extractErrorMessage(err: any): string {
    const msg = (err && err.error && err.error.message) ? err.error.message : '';

    if (!msg || msg.length > 100) {
      return 'An unexpected error occurred. Please try again.';
    }

    return msg;
  }

  hasChanges(): boolean {
    if (!this.selectedRowData) { return true; }

    const nameChanged = this.selectedMarketName.trim() !== (this.selectedRowData.marketName || '').trim();
    const statusChanged = this.selectedStatus !== this.selectedRowData.isActive;
    const partOf1ULChanged = this.selectedPartOf1UL !== this.selectedRowData.partOf1UL;

    // Compare follower market ids using the initial list we captured when popup loaded
    const originalFollowerIds = (this.initialSelectedFollowerMarketIds || []).slice().sort();
    const currentFollowerIds = (this.selectedFollowMarket || [])
      .map(m => m ? parseInt(m.marketId, 10) : NaN)
      .filter(id => !isNaN(id))
      .sort();
    const followersChanged = JSON.stringify(originalFollowerIds) !== JSON.stringify(currentFollowerIds);

    // Compare mapped countries (for Cluster) using the initial list we captured when popup loaded
    let mappedCountriesChanged = false;
    if (this.selectedMarketType === 'Cluster') {
      const originalMappedIds = (this.initialSelectedCountryIds || []).slice().sort();
      const currentMappedIds = (this.selectedCountries || [])
        .map(c => c ? parseInt(c.marketId, 10) : NaN)
        .filter(id => !isNaN(id))
        .sort();
      mappedCountriesChanged = JSON.stringify(originalMappedIds) !== JSON.stringify(currentMappedIds);
    }

    // Compare cluster selection
    const currentClusterCode = this.selectedPartOfCluster
      ? (typeof this.selectedPartOfCluster === 'object' ? this.selectedPartOfCluster.marketCode : this.selectedPartOfCluster)
      : null;
    const clusterChanged = currentClusterCode !== this.initialSelectedPartOfClusterCode;

    // Compare parent country for State
    let parentCountryChanged = false;
    if (this.selectedMarketType === 'State') {
      const currentParentId = this.selectedCountry
        ? (typeof this.selectedCountry === 'object' ? parseInt(this.selectedCountry.marketId, 10) : parseInt(this.selectedCountry, 10))
        : null;
      const originalParentId = this.initialSelectedCountryId != null ? parseInt(this.initialSelectedCountryId as any, 10) : null;
      parentCountryChanged = currentParentId !== originalParentId;
    }

    console.log('hasChanges evaluation:', {
      nameChanged: nameChanged,
      statusChanged: statusChanged,
      partOf1ULChanged: partOf1ULChanged,
      followersChanged: followersChanged,
      clusterChanged: clusterChanged,
      parentCountryChanged: parentCountryChanged,
      mappedCountriesChanged: mappedCountriesChanged
    });

    return nameChanged ||
      statusChanged ||
      partOf1ULChanged ||
      followersChanged ||
      clusterChanged ||
      parentCountryChanged ||
      mappedCountriesChanged;
  } onCountriesPanelHide() {
    this.isCountriesPanelOpen = false;
    this.updateFollowMarketOptions();
  }

  onFollowersPanelHide() {
    this.isFollowersPanelOpen = false;
    this.updateFollowMarketOptions();
  }

  onFollowMarketChange() {
    if (this.editPopup) {
      this.updateEditSubmitState();
    } else {
      this.enableOrDisable();
    }
    if (!this.isFollowersPanelOpen) {
      this.updateFollowMarketOptions();
    }
  }

  updateFollowMarketOptions() {
    // 1. Get currently selected follow market IDs and CTM IDs (parsed as integers)
    const selectedFollowerIds = new Set(
      (this.selectedFollowMarket || []).map((m: any) => {
        const id = typeof m === 'object' ? m.marketId : m;
        return id != null ? parseInt(id, 10) : NaN;
      }).filter((id: number) => !isNaN(id))
    );
    const selectedCountryIds = new Set(
      (this.selectedCountries || []).map((m: any) => {
        const id = typeof m === 'object' ? m.marketId : m;
        return id != null ? parseInt(id, 10) : NaN;
      }).filter((id: number) => !isNaN(id))
    );

    const sortSelectedFirst = (options: any[], selectedIds: Set<number>): any[] => {
      const selected = options.filter((o: any) => o.marketId != null && selectedIds.has(parseInt(o.marketId, 10)))
        .sort((a: any, b: any) => (a.marketName || '').localeCompare(b.marketName || ''));
      const unselected = options.filter((o: any) => o.marketId == null || !selectedIds.has(parseInt(o.marketId, 10)))
        .sort((a: any, b: any) => (a.marketName || '').localeCompare(b.marketName || ''));
      return [...selected, ...unselected];
    };

    // 2. Dynamically filter Countries to be Mapped (CTM) options
    if (this.editPopup) {
      // Filter CTM options from masterCountriesForEdit baseline
      if (this.masterCountriesForEdit && this.masterCountriesForEdit.length > 0) {
        const filtered = this.masterCountriesForEdit.filter((c: any) => {
          const cId = c.marketId != null ? parseInt(c.marketId, 10) : NaN;
          return isNaN(cId) || !selectedFollowerIds.has(cId);
        });
        this.allCountriesForEdit = sortSelectedFirst(filtered, selectedCountryIds);
      }
      // Clean up selected CTM list if any selected item is no longer in options
      if (this.selectedCountries && this.selectedCountries.length > 0) {
        const optionIds = new Set(this.allCountriesForEdit.map((o: any) => {
          const oId = o.marketId != null ? parseInt(o.marketId, 10) : NaN;
          return oId;
        }));
        this.selectedCountries = this.selectedCountries.filter((m: any) => {
          const mId = typeof m === 'object' ? (m.marketId != null ? parseInt(m.marketId, 10) : NaN) : parseInt(m, 10);
          return !isNaN(mId) && optionIds.has(mId);
        });
      }
    } else {
      // Filter CTM options from masterCountriesList baseline
      if (this.masterCountriesList && this.masterCountriesList.length > 0) {
        const filtered = this.masterCountriesList.filter((c: any) => {
          const cId = c.marketId != null ? parseInt(c.marketId, 10) : NaN;
          return isNaN(cId) || !selectedFollowerIds.has(cId);
        });
        this.allCountriesList = sortSelectedFirst(filtered, selectedCountryIds);
      }
      // Clean up selected CTM list if any selected item is no longer in options
      if (this.selectedCountries && this.selectedCountries.length > 0) {
        const optionIds = new Set(this.allCountriesList.map((o: any) => {
          const oId = o.marketId != null ? parseInt(o.marketId, 10) : NaN;
          return oId;
        }));
        this.selectedCountries = this.selectedCountries.filter((m: any) => {
          const mId = typeof m === 'object' ? (m.marketId != null ? parseInt(m.marketId, 10) : NaN) : parseInt(m, 10);
          return !isNaN(mId) && optionIds.has(mId);
        });
      }
    }

    // 3. Dynamically filter Follow Markets (FM) options
    const assessmentCodes = this.computedAssessmentOrder
      ? this.computedAssessmentOrder.split('>').map((x: string) => x.trim().toUpperCase())
      : [];
    const currentCode = this.selectedMarketCode ? this.selectedMarketCode.trim().toUpperCase() : '';
    const currentId = this.selectedRowData ? (this.selectedRowData.marketId != null ? parseInt(this.selectedRowData.marketId, 10) : null) : null;

    const currentlySelectedFollowerIds = new Set(
      (this.selectedFollowMarket || []).map(m => typeof m === 'object' ? parseInt(m.marketId, 10) : parseInt(m, 10)).filter(id => !isNaN(id))
    );

    const filteredFollowMarkets = this.allMarketsList.filter((m: any) => {
      const mId = m.marketId != null ? parseInt(m.marketId, 10) : NaN;
      const mCode = m.marketCode ? m.marketCode.trim().toUpperCase() : '';
      if (mCode && assessmentCodes.includes(mCode)) {
        return false;
      }
      if (currentCode && mCode === currentCode) {
        return false;
      }
      if (currentId != null && mId === currentId) {
        return false;
      }

      // Filter out mapped countries (for Cluster market type only)
      if (this.selectedMarketType === 'Cluster') {
        if (!isNaN(mId) && selectedCountryIds.has(mId)) {
          return false;
        }
        if (mCode && (this.selectedCountries || []).some((c: any) => (c.marketCode || '').trim().toUpperCase() === mCode)) {
          return false;
        }
      }

      // Exclude inactive markets unless they are currently selected
      const isActive = m.status === 'InUseMarket' || m.status === 'Active';
      const isCurrentlySelected = currentlySelectedFollowerIds.has(m.marketId);
      if (!isActive && !isCurrentlySelected) {
        return false;
      }

      return true;
    });

    this.followMarketOptions = sortSelectedFirst(filteredFollowMarkets, currentlySelectedFollowerIds);

    if (this.selectedFollowMarket && this.selectedFollowMarket.length > 0) {
      const optionIds = new Set(this.followMarketOptions.map((o: any) => o.marketId));
      this.selectedFollowMarket = this.selectedFollowMarket.filter((m: any) => optionIds.has(m.marketId));
    }
  }

  updateEditSubmitState() {
    if (!this.editPopup) { return; }

    this.validateDuplicates();

    const noErrors = !this.clusterCircularError && !this.cycleError && !this.isoCodeDuplicateError && !this.nameDuplicateError;

    let typeSpecificOk = false;
    if (this.selectedMarketType === 'Country') {
      typeSpecificOk = !!this.selectedStatus && !!this.selectedPartOf1UL;
    } else if (this.selectedMarketType === 'Cluster') {
      typeSpecificOk = !!this.selectedStatus && !!this.selectedPartOf1UL;
    } else if (this.selectedMarketType === 'State') {
      typeSpecificOk = !!this.selectedCountry && !!this.selectedStatus;
      if (this.isParentCountryInactive() && this.selectedStatus === '1') {
        typeSpecificOk = false;
      }
    }

    this.disableSubmitInEdit = !this.hasChanges() || !noErrors || !typeSpecificOk;
    // this.cdr.detectChanges();
  }

  isParentCountryInactive(): boolean {
    if (this.selectedMarketType !== 'State') {
      return false;
    }
    const cId = this.selectedCountry
      ? (typeof this.selectedCountry === 'object' ? this.selectedCountry.marketId : this.selectedCountry)
      : null;
    if (!cId) {
      return false;
    }
    const parentCountry = this.allMarketsList.find((m: any) => m.marketId === parseInt(cId, 10));
    if (!parentCountry) {
      return false;
    }
    const isActive = parentCountry.status === 'InUseMarket' || parentCountry.status === 'Active';
    return !isActive;
  }
}

